<script setup></script>
<template>
    <i class="fa-solid fa-trash"></i>
</template>
